<template>
  <div>
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible"
      :before-close="cancel"
      append-to-body>
        <el-form :model="form">
            <el-form-item label="国家">
                <el-input v-model="form.province" autocomplete="off" disabled="true"></el-input>
            </el-form-item>             
            <el-form-item label="同时在线数">
                <el-input v-model="form.online" autocomplete="off"></el-input>
            </el-form-item>            
            <el-form-item label="套餐总流量">
                <el-input v-model="form.flow_total" autocomplete="off"></el-input>
            </el-form-item>            
            <el-form-item label="过期时间">
                <el-date-picker
                    v-model="form.deadtime"
                    type="datetime"
                ></el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import {user_edit_meal} from '@/request/api.js'
export default {
    created(){
        this.form={...this.dialogData}
        if(this.dialogData.deadtime && this.dialogData.deadtime<=9999999999){
             this.form.deadtime = this.dialogData.deadtime*1000
        }
        
    },
    props:{
        dialogData: {
            type: Object,
            default: {},
        },
        dialogVisible:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            tableData:[],
            form:{}
        }
    },
    methods:{
        cancel(){
             this.$emit('update:dialogVisible',false)
        },
        submit(){
            let params={
                id:this.form.id,
                // flow_total:this.form.flow_total?parseInt(this.form.flow_total):0,
                flow_total:this.form.flow_total,
                online:this.form.online?parseInt(this.form.online):1
            }
            if(this.form.deadtime && this.form.deadtime>9999999999){
                params.deadtime = parseInt(this.form.deadtime/1000)
            }
            user_edit_meal(params).then(
                (res)=>{
                    if(res.status==0){
                        this.$message.success(res.detail)
                        this.$emit('freshData')
                        this.$emit('update:dialogVisible',false)
                    }else{
                        this.$message.error(res.detail)
                    }
                }
            )
        },
        readyToEdit(row){
            console.log(row);            
        }
    }
}
</script>

<style>

</style>